import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  isLoading: false,
};

export const userProfilesSlice = createSlice({
  name: "userProfiles",
  initialState,
  reducers: {
    updateUserProfiles: (state, action) => {
      return { ...action.payload };
    },
    clearUserProfiles: () => initialState,
  },
});

export const { updateUserProfiles, clearUserProfiles } =
  userProfilesSlice.actions;

export const userProfiles = (state) => state.userProfiles;

export default userProfilesSlice.reducer;
